import { NgModule } from '@angular/core';
import { SelectSearchComponent } from './select-search.component';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [SelectSearchComponent],
  imports: [CommonModule, IntrackFeatureModule, TranslateModule.forChild({}), SvgIconModule],
  exports: [SelectSearchComponent],
})
export class SelectSearchModule {}
